import store from '@/store/store'
import app from '@/main'

/* eslint-disable no-console */
export default socket => {
  socket.on('signalling', data => {
    // console.log('[Chat] Received data from signalling server:', data)

    switch (data.type) {
      case 'offer':
        store.commit('chat/SET_IS_CALLER', false)
        store.commit('chat/SET_ON_CALL_USER', data.from)

        window.localConnection
          .setRemoteDescription(data.data)
          .then(err => console.log('[Signalling] Offer Set Remote SDP Successful', err))
          .catch(err => console.log('[Signalling] Offer Set Remote SDP Error', err))

        //create an answer to an offer
        window.localConnection.createAnswer(
          answer => {
            console.log(`[Chat] Signalling answer sent to ${data.from}.`)

            window.localConnection
              .setLocalDescription(answer)
              .then(err => console.log('[Signalling] Offer Set Local SDP Successful', err))
              .catch(err => console.log('[Signalling] Offer Set Local SDP Error', err))

            app.$io.emit('signalling', {
              to: data.from,
              type: 'answer',
              data: answer
            })
          },
          error => {
            console.log('[Chat] Error in signalling answer sending:', error)
          }
        )
        if (app.$route.name !== 'chat') app.$router.push({ name: 'chat' })
        break

      case 'answer':
        console.log(`[Chat] Signalling answer received form ${data.from}.`)
        window.localConnection
          .setRemoteDescription(data.data)
          .then(err => console.log('[Signalling] Answer Set Remote Successful', err))
          .catch(err => console.log('[Signalling] Answer Set Remote Error', err))

        break

      case 'candidate':
        console.log(`[Chat] Signalling candidate received form ${data.from}.`)
        window.localConnection
          .addIceCandidate(data.data)
          .then(err => console.log('[Signalling] Candidate Add ICE Successful', err))
          .catch(err => console.log('[Signalling] Candidate Add ICE Error', err))

        break

      case 'end':
        console.log(`[Chat] Call ended received.`)
        store.commit('chat/SET_ON_CALL_USER', null)

        break
    }
  })
}
